import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { SnackbarKey, closeSnackbar, enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import ContractorService from "../../services/contractor/contractor.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
  OnEventArgs,
  SlickgridReactInstance,
  OperatorType,
  MultipleSelectEditor,
  ColumnEditor,
  createDomElement,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { Button, InputAdornment, TextField, Tooltip } from '@mui/material';
import { redirect, useLocation } from 'react-router-dom';
import { useState } from 'react';
import ContractorValidators from './validators';
import ContractorFormatters from './formatters';
import BorderSpinner from '../../components/Layout/spinner';
import ReactDOM from 'react-dom';
import contractorService from '../../services/contractor/contractor.service';


const location = window.location
  
const locationley = location.pathname.replaceAll('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class ContractorArchives extends BaseGrid {
  
  
    title = 'Kontrahenci';
    subTitle = 'Zarządzanie kontrahentami'
    Validators: any;
    Formatters: any;
    queryParameters : any;
    own_contractor_groups : string[];

    lastApiCall : Date;
   //props : BasicGridProps=
 constructor(public readonly props: BasicGridProps) {
    super(props);
    this.Validators = new ContractorValidators(this)
    this.Formatters = new ContractorFormatters(this)
    this.own_contractor_groups = []
    this.lastApiCall = new Date(0)

    this.queryParameters = new URLSearchParams(window.location.search)
    //this.group_name = queryParameters.get("group_name")
    
    
 }


setSearchFilter() {
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

shortnameFormatter = (row: any, cell: any, value: any, columnDef: any, dataContext: any) =>{
  var ownContractor = authService.isAdmin() 
  if (!ownContractor){
    if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
       for (const group in dataContext?.group_names_array){
         if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
          ownContractor = true;
            break;
         }  
       }
    }else{
      ownContractor = false;
    }
  }
  let s=""
  if ( dataContext.shortname !=null){
    if (ownContractor){
      s ="<a class='slickRowLink' href='/contractors/card/" + dataContext.id + "' >" + dataContext.shortname + "</a>";
    }else{
       s=dataContext.shortname
    } 
  }
  return s;
};

canDelete = (dataContext: any)  =>{
  var canDelete = authService.isAdmin() 
  if (!canDelete){
    if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
       for (const group in dataContext?.group_names_array){
         if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
           canDelete = true;
            break;
         }  
       }
    }else{
       canDelete = false;
    }
  }
  return canDelete;
} 
deleteFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
  
 if (this.canDelete(dataContext)){
   return createDomElement('i', { className: 'fa fa-trash pointer', ariaHidden: 'true' });
 }else{
   return ''
 }
};

reactGridReady(reactGrid: SlickgridReactInstance) {
   super.reactGridReady(reactGrid);

   if (this.queryParameters){ 
      var group_name = this.queryParameters.get("group_name")
      if (group_name!=null && group_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'group_names_array', searchTerms: [group_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }
      var label_name = this.queryParameters.get("label")
      if (label_name!=null && label_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'labels_array', searchTerms: [label_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }
      var classification_name = this.queryParameters.get("classification")
      if (classification_name!=null && classification_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'classifications_array', searchTerms: [classification_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }
      var city_name = this.queryParameters.get("city")
      if (city_name!=null && city_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'city', searchTerms: [city_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }

    }	       
}

onStorage = () => {
  this.setSearchFilter()
  window.dispatchEvent(new Event('serchcontractors'));
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
  window.addEventListener("resize",this.onResize)
  this.onResize()
  
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
  window.removeEventListener("resize",this.onResize)
};

onResize = () =>{
  setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
}


  
componentDidMount() {

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();

  this.getcontractorlookups();
    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}


restoreArchive(){
  var selectedCount=0;
  var list='';
  var selectedData = [],
      selectedIndexes;
  var list='';
  var selectedCount=0;
  
  selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();
  if (selectedIndexes.length>0){
     selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();
   if (selectedIndexes.length>0){
    if (window.confirm('Ilość kontrahentów do przywrucenia: ' + selectedIndexes.length + '\nCzy potwierdzasz?')){
      var that = this  
      jQuery.each(selectedIndexes, function (index, value) {
          selectedCount++;
          var SelectedID = that.reactGrid.slickGrid.getDataItem(value).id;
          if (list==''){
            list= String(SelectedID);
          }else{
            list=list+',' + String(SelectedID);
          }
        });
        contractorService.restoreArchival(list).then( (resp) => {
          console.log(resp)
            alert('Poprawnie przywrócono ' + resp + ' kontrahentów(a)')
            //this.setState((state: State, props: BasicGridProps) => ({
            //  ...state,
            //  alertInfo: 'Poprawnie przywrócono ' + resp + ' kontrahentów',
            //}));
            window.location.reload()
         }).catch( error => {
          console.log(error)
         })
      }
    }
   }else{
      alert('Wybierz kontrahentów do przywrócenia');
   }
}


 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);
    
    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;

    
    }

    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

//componentDidUpdate(PrevProps: any, prevState: State){
//  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){

 //     if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
        //alert(prevState.alertErrorMsg)
 //     }
 // }   
  
//}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editContractorApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 

              window.dispatchEvent(new Event('serchcontractors'));
              
            }
            var center = document.getElementById('center');
            localStorage.setItem(this.query_key, query)
            return this.getContractorApiCall(query)},
          postProcess: (response) => {
            if (new Date(response.metrics.startTime) > this.lastApiCall){
              this.lastApiCall = new Date(response.metrics.startTime)
              this.setState(
                (state: State) => ({ ...state, metrics: response.metrics }),
                () => this.postProcessCallback(response)
              );
            }
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  onCellValidationError(_e: Event, args: any) {
    if (args.validationResults) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }

  

  getcontractorlookups(){
    return ContractorService.getcontractorlookups().then(response => {

          let tmp1: LookupCollection[] = []
          if ((response.data) && (Array.isArray(response.data))){
              tmp1  = response.data
          }
          this.setState((state: State) => ({
            ...state,
            lookupData : tmp1
          }),  () => {
            ContractorService.getOwnContractorGroups().then(response => { 
              if ((response) && (Array.isArray(response))){
                this.own_contractor_groups = response  
              }else{
                this.own_contractor_groups = []
              }
              this.defineGrid()
          

            }
            ).catch(
              () => {
                let tmp : LookupData[] = [];
                this.setState((state: State, props: BasicGridProps) => ({
                      ...state,
                      alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
                }));
                this.own_contractor_groups=[]
                return tmp;
              }
            )

           

            }
          );

     
    }
       
    ).catch(
      () => {
        let tmp : LookupData[] = [];
        this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
        }));
        return tmp;
      }
    )
  }



  getColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = [];
    let data_contractorgroups: any[] = [];
    let data_contractorstates : any[] = [];
    let data_fairs : any[] = [];
    let data_contractortrades : any[] = [];
    let data_newmstate : any[] = [];
    let data_iis : any[] = [];
    let data_classifications : any[] = [];
    let data_ctypes : any[] = [];
    let data_gtu : any[] = [];
    //Adam To do
    this.state.lookupData?.forEach((item) => {
      if (item.name === 'contractorgroups'){
        data_contractorgroups = item.data; 
      } 
      else if (item.name === 'contractorstates'){
        data_contractorstates = item.data; 
      } 
      else if (item.name === 'fairs'){
        data_fairs = item.data; 
      }
      else if (item.name === 'contractortrades'){
        data_contractortrades = item.data; 
      }  
      else if (item.name === 'newmstates'){
        data_newmstate = item.data; 
      }  
      else if (item.name === 'iis'){
        data_iis = item.data; 
      }  
      else if (item.name === 'classifications'){
        data_classifications = item.data; 
      }  
      else if (item.name === 'contractortypes'){
        data_ctypes = item.data; 
      }  
      else if (item.name === 'gtu'){
        data_gtu = item.data; 
      }  
      
    });
      
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: this.deleteFormatter, // Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteContractorFormatter.bind(this) as Formatter
          },    
        }
      );

    
    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'shortname', name: 'Nazwa skrócona', field: 'shortname', sortable: true, filterable: true,
        type: FieldType.string,
        formatter:this.shortnameFormatter,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          validator : this.Validators.shortnameValidator,
          maxLength:3,
          compositeEditorFormOrder : 2,
          
        },
        hidden:false,
        minWidth:  100 
        
      },

      {
        id: 'name', name: 'Nazwa', field: 'name', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          validator : this.Validators.nameValidator,
          maxLength:3,
          compositeEditorFormOrder : 3,
          
        },
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'contactdate', name: 'Data kontaktu', field: 'contactdate', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        editor: {model: Editors.date,
          compositeEditorFormOrder : 4,
          editorOptions:{enableTime:true},
          massUpdate: true,
          
        },
        
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'group_names_array', name: 'Grupa', field: 'group_names_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.Formatters.groupFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_contractorgroups},
        editor: {model: Editors.multipleSelect,
          collection: data_contractorgroups,
          compositeEditorFormOrder : 5,
        },
        onCellChange: this.ongroupNamesChange,
        queryField: 'group_names',
        minWidth:100
      },
      {
        id: 'contractor_state', name: 'Status', field: 'contractor_state', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_contractorstates, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_contractorstates,
          massUpdate: true,
          compositeEditorFormOrder : 6,
        },
        
        minWidth:100
      },
      {
        id: 'labels_array', name: 'Etykiety', field: 'labels_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.Formatters.labelFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_fairs},
        editor: {model: Editors.multipleSelect,
          collection: data_fairs,
          compositeEditorFormOrder : 7,
        },
        onCellChange: this.onLabelChange,
        queryField: 'labels',
        minWidth:100
      },
      {
        id: 'trade_name', name: 'Branża', field: 'trade_name', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_contractortrades, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_contractortrades,
          compositeEditorFormOrder : 8,
          massUpdate: true,
        },
        
        minWidth:100
      },
      
      {
        id: 'mail', name: 'E-mail z NL', field: 'mail', sortable: true, filterable: true,
        excludeFromColumnPicker: true,
        formatter: this.Formatters.mailFormatter,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.emailValidator,
          maxLength:100,
          compositeEditorFormOrder : 9
        },
        minWidth:100
      },
      {
        id: 'phone', name: 'Telefon', field: 'phone', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.phoneValidator,
          maxLength:100,
          compositeEditorFormOrder : 10
        },
        minWidth:100
      },
      {
        id: 'contractor_newmstate', name: 'Wysyłka Mailingu', field: 'contractor_newmstate', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_newmstate, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_newmstate,
          compositeEditorFormOrder : 11,
        },
        
        minWidth:100
      },
      {
        id: 'iis_name', name: 'Spis inwestycji', field: 'iis_name', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_iis, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_iis,
          compositeEditorFormOrder : 12,
          massUpdate: true,
        },
        
        minWidth:100
      },
      {
        id: 'classifications_array', name: 'Klasyfikacja', field: 'classifications_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.Formatters.classificationFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_classifications},
        editor: {model: Editors.multipleSelect,
          collection: data_classifications,
          compositeEditorFormOrder : 13,
          massUpdate: true,
        },
        onCellChange: this.onClassificationChange,
        queryField: 'classifications',
        minWidth:150
      },
      {
        id: 'unsub_eml', name: 'Email rezygnacja z NL', field: 'unsub_eml', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
      {
        id: 'unsub_tel', name: 'Telefon rezygnacja z NL', field: 'unsub_tel', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 15,
        },
        
        minWidth:50
      },
      {
        id: 'nip', name: 'NIP', field: 'nip', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.nipValidator,
          maxLength:100,
          compositeEditorFormOrder : 1,
        },
        minWidth:100
      },
      {
        id: 'regon', name: 'REGON', field: 'regon', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.regonValidator,
          maxLength:100,
          compositeEditorFormOrder : 16
        },
        minWidth:100
      },
      {
        id: 'krs', name: 'KRS', field: 'krs', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.regonValidator,
          maxLength:100,
          compositeEditorFormOrder : 17
        },
        minWidth:100
      },
      {
        id: 'webpage', name: 'Strona WWW', field: 'webpage', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        formatter:this.Formatters.webpageFormatter,
        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 18,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'fax', name: 'FAX', field: 'fax', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.phoneValidator,
          maxLength:100,
          compositeEditorFormOrder : 19
        },
        minWidth:100
      },
      {
        id: 'postcode', name: 'Kod pocztowy', field: 'postcode', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.postcodeValidator,
          maxLength:20,
          compositeEditorFormOrder : 20
        },
        minWidth:100
      },
      {
        id: 'city', name: 'Miasto', field: 'city', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        formatter:this.Formatters.cityFormatter,
        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 21,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'street', name: 'Ulica', field: 'street', sortable: true, filterable: true,
        type: FieldType.string,  
        excludeFromColumnPicker: true,      
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 22,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'province', name: 'Województwo', field: 'province', sortable: true, filterable: true,
        type: FieldType.string, 
        excludeFromColumnPicker: true,       
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 23,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'country', name: 'Państwo', field: 'country', sortable: true, filterable: true,
        type: FieldType.string, 
        excludeFromColumnPicker: true,       
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 24,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },


      {
        id: 'cor_postcode', name: 'Kod pocztowy(adres kor.)', field: 'cor_postcode', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.postcodeValidator,
          maxLength:25,
          compositeEditorFormOrder : 20
        },
        minWidth:100
      },
      {
        id: 'cor_city', name: 'Miasto (adres kor.)', field: 'cor_city', sortable: true, filterable: true,
        type: FieldType.string,
        formatter:this.Formatters.cityFormatter,
        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 26,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'cor_street', name: 'Ulica (adres kor.)', field: 'cor_street', sortable: true, filterable: true,
        type: FieldType.string,        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 27,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'cor_province', name: 'Województwo (adres kor.)', field: 'cor_province', sortable: true, filterable: true,
        type: FieldType.string,        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 28,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'cor_country', name: 'Państwo (adres kor.)', field: 'cor_country', sortable: true, filterable: true,
        type: FieldType.string,        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 29,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'contractor_type', name: 'Typ', field: 'contractor_type', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_ctypes, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_ctypes,
          compositeEditorFormOrder : 30,
          massUpdate: true,
        },
        
        minWidth:100
      },
      {
        id: 'isperson', name: 'Osoba fizyczna', field: 'isperson', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 31,
        },
        
        minWidth:50
      },
      {
        id: 'sendmail', name: 'Przypomnienie', field: 'sendmail', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 32,
        },
        
        minWidth:50
      },
      {
        id: 'gtu_array', name: 'Grupa towarowa', field: 'gtu_array', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.multipleSelect,
          collection: data_gtu,
          compositeEditorFormOrder : 33,
          
          //collectionFilterBy: [{
          //  property: 'index',
          //  operator: OperatorType.equal,
          //  value: 
          //},] 
          
        },
        
        minWidth:100
      },
      {
        id: 'created', name: 'Data utworzenia', field: 'created', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange,},           
        hidden:false,
        minWidth:100   
      },
      {
        id: 'modified', name: 'Data edycji', field: 'modified', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100   
      },

      {
        id: 'archival', name: 'Archiwalny', field: 'archival', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 34,
        },
        
        minWidth:50
      },
   
    );
    
    
    tmp = this.customizeHeaderMenu(tmp)

    return tmp
  }

  ongroupNamesChange(e: Event, args: OnEventArgs){
    if (args.columnDef.field == 'group_names_array'){
        if (Array.isArray(args.dataContext['group_names_array']))
          args.dataContext['group_names'] = args.dataContext['group_names_array'].join(', ')
    }else{
      args.dataContext['group_names'] = ''
    }
  }
  onNIPChange(e: Event, args: OnEventArgs){
    console.log('AAAAA')
    if (args.columnDef.field == 'nip'){
       // if (Array.isArray(args.dataContext['group_names_array']))
       //   args.dataContext['group_names'] = args.dataContext['group_names_array'].join(', ')
       console.log('DDDD')
       args.dataContext['name'] = 'AAAA' 
    }else{
       //args.dataContext['group_names'] = ''
    }
  }

  onClassificationChange(e: Event, args: OnEventArgs){
    if (args.columnDef.field == 'classifications_array'){
        if (Array.isArray(args.dataContext['classifications_array']))
          args.dataContext['classifications'] = args.dataContext['classifications_array'].join(', ')
    }else{
      args.dataContext['classifications'] = ''
    }
  }

  onLabelChange(e: Event, args: OnEventArgs){
    if (args.columnDef.field == 'labels_array'){
        if (Array.isArray(args.dataContext['labels_array']))
          args.dataContext['labels'] = args.dataContext['labels_array'].join(', ')
    }else{
      args.dataContext['labels'] = ''
    }
  }


  groupClicked(e: Event, args: OnEventArgs){
    //alert('aaa')
    //console.log(e);
    //console.log(args);
  }

  deleteContractorFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Użytkownik:</div> <div>${dataContext.firstname} ${dataContext.shortname}</div></div>`;
  }

  getContractorApiCall(query: string) {
    return ContractorService.getarchives(query)
  }
  editContractorApiCall(data: any) {  
    if ((data.contactdate == '') || ((data.contactdate == null))){
     // var tmpDate = data.contactdate.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
     //data.contactdate = tmpDate[0] + 'T00:00:00'
     data.contactdate=0;
    }//else{
      //data.contactdate=0;
    //}

    ContractorService.editcontractor(data).then(
        
         () =>  {
          if (data.contactdate==0){
            data.contactdate=''
          }

          this.reactGrid.slickGrid.invalidate()
          
        }
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowego kontrahenta';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie kontrahenta - {{shortname}}';
          break;
        case 'edit':
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów';
            modalType = 'mass-selection';
            var selectedIDs : number[] = []
            selecttedcount.forEach(element => {
              selectedIDs.push(this.reactGrid.slickGrid.getDataItem(element).id)
            });
            console.log('AAAAAA')
            console.log(selecttedcount)
            console.log('BBBBBBB')
            console.log(selectedIDs)
          }else{
            modalTitle = 'Edycja kontrahenta - (<span class="text-muted"></span><span class="text-primary">NIP: {{nip}}</span>)'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jednego kontrahenta do edycji!');
      }else{
        alert('Nie wybrano kontrahenta do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (modalType = 'mass-selection'){
              //alert('mass-selection')
              this.displaySpinner(true);
              let tmp = {...formValues}

                if (tmp.contactdate == ''){
                  //var tmpDate = tmp.contactdate.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
                  //tmp.contactdate = tmpDate[0] + 'T00:00:00'
                  tmp.contactdate=0;
                }//else{
                 // tmp.contactdate=0;
               // }
             
             
              if (selectedIDs && Array.isArray(selectedIDs) && selectedIDs.length>0){
                
                ContractorService.massEdit(selectedIDs, tmp).then(
                  (data) => {
                    //this.reactGrid.filterService.updateFilters([])
                    
                   // this.setState((state: State, props: BasicGridProps) => ({
                   //   ...state,
                   //   alertInfo: "Zaktualizowano: " + data + " kontrahentów!"
                   // }));
                    this.displaySpinner(false);
                    alert("Zaktualizowano: " + data + " kontrahentów!")
                    window.location.reload() 
                  }
                  ).catch(
                    (error) => {
                      this.displaySpinner(false);
                      try{   
                        console.log(error)
                        if (error && error.response && error.response.data && error.response.data.detail){
                          this.setState((state: State, props: BasicGridProps) => ({
                            ...state,
                            alertError: "Błąd: " + error.response.data.detail
                          }));
                        }else{          
                          this.setState((state: State, props: BasicGridProps) => ({
                            ...state,
                            alertError: "Błąd podczas masowej edycji kontrahentów"
                          }));
                        }
                        
                      }catch{
            
                      }
                    }
                  )   
              }

              

            }else{
              if (_selection.gridRowIndexes.length===0){
                let tmp = {...dataContext, id:null}

                if (tmp.contactdate == ''){
                  tmp.contactdate=0;
                  //var tmpDate = tmp.contactdate.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
                  //tmp.contactdate = tmpDate[0] + 'T00:00:00'
                }//else{
                 // tmp.contactdate=0;
               // }

                ContractorService.addcontractor(tmp).then(
                  (data) => {
                    //this.reactGrid.filterService.updateFilters([])
                    if (data.contactdate==0){
                      data.contactdate=''
                    }
                    this.reactGrid.slickGrid.invalidate()
                  }
                  ).catch(
                    (error) => {
                      try{   
                        console.log(error)
                        if (error && error.response && error.response.data && error.response.data.detail){
                          this.setState((state: State, props: BasicGridProps) => ({
                            ...state,
                            alertError: "Błąd: " + error.response.data.detail
                          }));
                        }else{          
                          this.setState((state: State, props: BasicGridProps) => ({
                            ...state,
                            alertError: "Błąd podczas dodawania kontrahenta"
                          }));
                        }
                        
                        var tmp = this.reactGrid.slickGrid.getData().getItems()
                        tmp.splice(0,1);
                        
                        this.reactGrid.slickGrid.getData().setItems(tmp)
                      }catch{
            
                      }
                    }
                  )   
              }
          }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e: Event, args: any) {
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);
    if (metadata.columnDef.id === 'delete') {
      if (this.canDelete(metadata.dataContext)){
        if (window.confirm('Czy potwierdzasz usunięcie kontrahenta: ' + metadata.dataContext.shortname + '?')) {
          ContractorService.deletecontractor(metadata.dataContext.id).then(
            () => {
              this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertInfo: `Usunięto: ${metadata.dataContext.shortname}`,
              }));
          }

          ).catch(
            () => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: `Wystąpił problem przy usuwaniu kontrahenta: ${metadata.dataContext.shortname}`,
              }));
            }
          )
          
          
        }
      }
    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    const gridOptions = grid.getOptions() as GridOption;
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
  
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = authService.isAdmin() 
      if (!authService.isAdmin()){
        if ((dataContext?.archival == null) || (dataContext?.archival <=0)){
          if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
              for (const group in dataContext?.group_names_array){
                if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
                  isEditable = true;
                  break;
                }  
              }
          }else{
            isEditable = false;
          }
        }else{
          isEditable = false;
        }
      }else{
        isEditable = true;
      } 
    }
    return isEditable;
  }

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return true;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    const columnDef = args.column;
    const formValues = args.formValues;
    if (columnDef.field === 'nip' && formValues.nip.length >= 10) {
          ContractorService.getExternalData(formValues.nip).then(response => {
          if (response.nip == formValues.nip){
            if (response.name != null) {this.compositeEditorInstance.changeFormInputValue('name', response.name);}
            if (response.shortname != null) {this.compositeEditorInstance.changeFormInputValue('shortname', response.shortname);}
            if (response.regon != null) {this.compositeEditorInstance.changeFormInputValue('regon', response.regon);}
            if (response.krs != null) {this.compositeEditorInstance.changeFormInputValue('krs', response.krs);}
            if (response.country != null) {this.compositeEditorInstance.changeFormInputValue('country', response.country);}
            if (response.city != null) {this.compositeEditorInstance.changeFormInputValue('city', response.city);}
            if (response.street != null) {this.compositeEditorInstance.changeFormInputValue('street', response.street);}
            if (response.postcode != null) {this.compositeEditorInstance.changeFormInputValue('postcode', response.postcode);}
            if (response.webpage != null) {this.compositeEditorInstance.changeFormInputValue('webpage', response.webpage);}
            if (response.province != null) {this.compositeEditorInstance.changeFormInputValue('province', response.province);}
            if (response.mail != null) {this.compositeEditorInstance.changeFormInputValue('mail', response.mail);}
            if (response.isperson != null) {this.compositeEditorInstance.changeFormInputValue('isperson', response.isperson);}
          }else{
            console.log('Not find in external sources')
          } 
                
       }).catch(
            (error: any) => {
              console.log(error)
    
            }
        );
          
    }
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;
    //column?.editor.collection = [];
    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }


  action(snackbarId: SnackbarKey){
    return(
    <>
       <Button  onClick={() => { closeSnackbar(snackbarId) }} variant="contained">Zamknij</Button>
      
    </>
    )
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }
    //console.log(this.state.alertErrorMsg)
    if (this.state.alertErrorMsg.length > 0){
      for (const msg in this.state.alertErrorMsg){
        enqueueSnackbar(this.state.alertErrorMsg[msg], {action: this.action, variant: 'warning', preventDuplicate: true,  autoHideDuration:5000, persist: true})
      }
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
           { authService.isAdmin() && <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>

            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.restoreArchive()}
              >
                <Tooltip title="Przywróć">
                <i className="fas fa  fa-box-open nav-icon" />
                </Tooltip>
            </button>
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          
          <SlickgridReact gridId="contractor-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(ContractorArchives);

